import { Cover, COVER_TYPE_TEMPLATE } from './Cover'
import { CoverSheet } from './CoverSheet'
import { CoverBarcodes } from './CoverBarcodes'
import { getGoogleFontsLink } from '@/config/japaneseFonts'

/* Шрифты штрихкодов — те же, что использует печать. */
const BARCODE_FONTS_LINK = '<link href="https://fonts.googleapis.com/css2?family=B612+Mono&family=Libre+Barcode+EAN13+Text&display=swap" rel="stylesheet">'

/*
  Обложка на основе шаблона: лицевая и задняя стороны — обычные Page-документы проекта,
  живущие в подколлекции pages вне sheets (поэтому не попадают в нумерацию, лимит страниц,
  расчёт корешка и план печати страниц).

  Страницы лежат в project.coverPages: { back, variants: { 'cover-a': Page, ... } }.
  На каждый вариант обложки — свой документ, поэтому правки не теряются при переключении.
*/
class TemplateCover extends Cover {
  get type () {
    return COVER_TYPE_TEMPLATE
  }

  get templateCoverId () {
    return this.data.templateCoverId || this.project?.coverTemplate?.variants?.[0]?.id || ''
  }

  get variants () {
    return this.project?.coverPages?.variants || {}
  }

  get frontPage () {
    return this.variants[this.templateCoverId] || null
  }

  get backPage () {
    return this.project?.coverPages?.back || null
  }

  get pages () {
    return [this.backPage, this.frontPage].filter(Boolean)
  }

  /* Описание выбранного варианта из шаблона обложки (коллекция covers). */
  get templateCover () {
    return this.project?.coverTemplate?.getVariant(this.templateCoverId) || null
  }

  /* Вылет заложен внутрь страницы обложки: 151×216 при обрезном 148×210. */
  get bleedMm () {
    const pageHeight = this.frontPage?.format?.height
    const trimHeight = this.project?.template?.printInfo?.format?.height

    if (!pageHeight || !trimHeight || pageHeight <= trimHeight) return undefined

    return (pageHeight - trimHeight) / 2
  }

  /* Готовность = вариант выбран и страницы созданы. Фото-слоты опциональны:
     дизайн работает и без загруженных изображений. */
  isComplete () {
    return Boolean(this.frontPage && this.backPage)
  }

  createSheet () {
    if (!this.frontPage || !this.backPage) return null

    return new CoverSheet({
      pages: this.pages,
      format: this.frontPage.format,
      spine: this.createSpine(this.bleedMm),
      backSide: this.backPage.side,
      barcodes: new CoverBarcodes({
        isbn: this.project?.isbn,
        jan: this.project?.getJanCode?.(),
        retailPrice: this.project?.retailPrice
      }),
      fontsLink: getGoogleFontsLink() + BARCODE_FONTS_LINK
    })
  }
}

export { TemplateCover }
